
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coupon",
      function () {
        return require("private-next-pages/coupon.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coupon"])
      });
    }
  